import { Component, DestroyRef, HostListener, OnDestroy, OnInit, inject } from '@angular/core';
import { RenderGridComponent } from '../render-grid/render-grid.component';
import { ActivatedRoute, Router } from '@angular/router';
import { getStorage, ref } from "firebase/storage";
import localforage from 'localforage';
import { BaseState } from '../../reducers';
import { Store } from '@ngrx/store';
import { filter, map, take ,interval, of } from 'rxjs'; import { FirebaseApp } from '@angular/fire/app';
import { getDownloadURL } from '@angular/fire/storage';
import { HttpClient } from '@angular/common/http';
import { AsyncPipe } from '@angular/common';
import { ImageDrawService } from '../../services/image-draw.service';
import { Firestore } from '@angular/fire/firestore';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { resetEditorState, saveRenderToFirebase } from '../store/editor.actions';
import { Analytics, logEvent } from '@angular/fire/analytics';
import { driver } from 'driver.js';
import { RawImageDataLoaderService } from '../../services/image-loader.service';
import { RenderDataActionsService } from '../../services/render-data-actions.service';

enum LoadingState {
  Idle = "Idle",
  Downloading = "Downloading",
  Decompressing = "Decompressing"
}

@Component({
  selector: 'app-demo-container',
  standalone: true,
  imports: [
    RenderGridComponent,
    ProgressSpinnerModule
  ],
  templateUrl: './demo-container.component.html',
  styleUrl: './demo-container.component.scss'
})
export class DemoContainerComponent implements OnDestroy {
  firebaseApp = inject(FirebaseApp)
  firestore = inject(Firestore)
  analytics = inject(Analytics)
  renderDataActionService = inject(RenderDataActionsService)

  loading = true
  loadingState: LoadingState = LoadingState.Idle

  loadRender$ = of(1).pipe(
    filter((userId) => !!userId),
    take(1),
    map(async (): Promise<{buf: ArrayBuffer}> => {
      this.loadingState = LoadingState.Downloading
      const renderId = this.activatedRoute.snapshot.params['id']
      const baseDataId = renderId
      const localRender = await localforage.getItem<ArrayBuffer>(`demo/${baseDataId}`)
      if (localRender !== null) {
        return {buf: localRender}
      }
      const storage = getStorage(this.firebaseApp, "gs://demo-renders");
      let url: string
      try {
        url = await getDownloadURL(ref(storage, `${baseDataId}`))
      } catch (e) {
        this.router.navigate(['home'])
      }
      return new Promise((resolve) => {
        this.httpClient.get(url, {responseType: 'arraybuffer'}).subscribe((blob) => {
          localforage.setItem(`demo/${baseDataId}`, blob).then(() => {
            resolve({buf: blob})
          })
        })
      })
    }),
    map(async (result) => {
      const data = await result
      this.loadingState = LoadingState.Decompressing
      await this.imageLoaderService.loadImageFromFile(data.buf)
      this.renderDataActionService.setRenderData()
      this.loadingState = LoadingState.Idle
      this.startGuidedTour()
      return true
    })
  )

  startGuidedTour() {
    localforage.getItem<boolean>('tutorial-complete').then((allowClose) => {
      setTimeout(() => {
        const driveObj = driver({
          popoverClass: 'rorender-theme',
          showProgress: true,
          allowClose: !!allowClose,
          steps: [
              { popover: { title: 'RoRender Editor Demo', description: 'Welcome to the RoRender Editor, let me show you around real quick. <br><br> <i>This is render of the village map which you can find on the Studio Templates page.</i>' } },
              { element: '#render-view', popover: { title: 'Viewport', description: 'The Viewport shows a live preview of your map as you edit in real time. <br><br><i>Note that some effects may appear slightly different in the full sized image due to scaling.</i>', side: "bottom", align: 'center'}},
              { element: '#layer-adder', popover: { title: 'Layer / Effect Picker', description: 'Add layers and effects to customize your map. Blue icons represent individual layers, while green icons are effects applied to those layers', side: "right", align: 'center'}},
              { element: '#layer-list', popover: { title: 'Layer List', description: 'Select layers and adjust their order to control how layers and effects are applied to your map.', side: "top", align: 'center'}},
              { element: '#properties', popover: { title: 'Properties Panel', description: 'Adjust settings for the selected layer or effect here. Changes update in real time in the viewport.', side: "left", align: 'center'}},
              { element: '#presets', popover: { title: 'Presets', description: 'Try our presets to see what’s possible! Logged-in users can create and save custom presets that sync seamlessly across renders.', side: "top", align: 'end'}},
              { element: '#export-button', popover: { title: 'Export', description: 'When you are done, save your work as a PNG or a ZIP file with each layer as a separate image.', side: "top", align: 'end'}},
              { popover: { title: 'All Done!', description: 'I reccomend trying out the Google Map preset to see a cool example of what can be done in editor with RoRender, otherwise play around with the editor. <br><br>Happy editing!' } },
          ]
        })
        driveObj.drive()
        localforage.setItem('tutorial-complete', true)
      }, 300)
    })
  }


  ngOnDestroy(): void {
    //this.imageDrawService.releaseMemory()
  }

  constructor(
    private activatedRoute: ActivatedRoute,
    private store: Store<BaseState>,
    private httpClient: HttpClient,
    private imageDrawService: ImageDrawService,
    private imageLoaderService: RawImageDataLoaderService,
    private router: Router
  ) {
    this.loadRender$.subscribe(async (output) => {
      const loaded = await output
      this.loading = !loaded
    })
    this.store.dispatch(resetEditorState())
    logEvent(this.analytics, "view_demo")
  }
}
